export type RunScope = 'all' | 'org' | 'auto';
export type LogsSortBy = 'createdAt' | 'flowName' | 'status';
export type PeriodPreset = '24h' | '7d' | '30d' | 'custom';

// Espelha MAX_OVERVIEW_WINDOW_DAYS do tarken-automations: o /overview e o unico endpoint
// cross-org (sem filtro de organizacao), entao varre o volume de todos os clientes somados
// e o servidor rejeita janela maior que isso com HTTP 400.
export const MAX_ANALYTICS_WINDOW_DAYS = 30;

export interface PeriodState {
  preset: PeriodPreset;
  since: string;
  until: string;
}
